import React, { useMemo } from 'react';
import classnames from 'classnames';
import LinkJump from '@gp/components/LinkJump';
import {
  getProjectDetailsPagePath,
  goToProjectDetailsPageByPath,
  IProjectDetailsPathUtilsParams,
} from '@gp/utils/project';
import { BoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportHightlightVO } from '@gp/types/dpsReport/v2';

import './index.scss';

interface ICardProps extends IBaseProps {
  data?: IDPSReportHightlightVO;
}

const Card: React.FC<ICardProps> = (props) => {
  const { style, className, data } = props;

  const { project_id: projectId, project, milestone, studio, is_gr: isGR } = data || {};

  const params = useMemo<IProjectDetailsPathUtilsParams>(
    () => ({
      id: projectId as any,
      name: project || '',
      tab: 'milestone',
    }),
    [projectId, project],
  );

  const url = useMemo<string>(() => getProjectDetailsPagePath(params), [params]);

  return (
    <LinkJump url={url}>
      <div
        style={style}
        className={classnames('dbg-dps-report-hightlights-card', className)}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          goToProjectDetailsPageByPath(url);
        }}
      >
        <div
          className={classnames('dbg-dps-report-hightlights-card__header dbg-milestone-color', {
            'dbg-milestone-gr-color': isGR === BoolFlag.True,
          })}
        ></div>
        <div className="dbg-dps-report-hightlights-card__body">
          <p className="dbg-dps-report-hightlights-card__p">{milestone || '-'}</p>
          <p className="dbg-dps-report-hightlights-card__p-main">
            <span>{project || '-'}</span>
          </p>
          <p className="dbg-dps-report-hightlights-card__p">{studio}</p>
        </div>
      </div>
    </LinkJump>
  );
};

export default Card;
